import {
  TrendingUp,
  Atom,
  BarChart3,
  Code2,
  BookOpen,
  GraduationCap,
} from "lucide-react";

const mainCourses = [
  {
    name: "Cálculo",
    description:
      "Límites, derivadas, integrales y series. Material paso a paso con visualizaciones claras.",
    icon: TrendingUp,
    available: true,
  },
  {
    name: "Física",
    description:
      "Mecánica, termodinámica y ondas. Problemas resueltos con enfoque práctico.",
    icon: Atom,
    available: true,
  },
  {
    name: "Probabilidades y Estadística",
    description:
      "Distribuciones, inferencia y análisis de datos. Explicaciones directas y aplicadas.",
    icon: BarChart3,
    available: true,
  },
  {
    name: "Programación",
    description:
      "Python, algoritmos y estructuras de datos. Desde lo básico hasta lo que exigen en la U.",
    icon: Code2,
    available: true,
  },
];

const futureCourses = [
  {
    name: "Álgebra Lineal",
    description: "Vectores, matrices, transformaciones y espacios vectoriales.",
    icon: BookOpen,
    available: false,
  },
  {
    name: "Otros cursos del plan común",
    description:
      "Química, Ecuaciones Diferenciales y más ramos de ingeniería.",
    icon: GraduationCap,
    available: false,
  },
];

export default function CourseCatalog({ onCourseSelect }) {
  return (
    <section
      id="cursos"
      data-testid="course-catalog"
      className="py-20 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl mb-14">
          <p className="text-sm uppercase tracking-[0.2em] text-[#c77dff] font-semibold mb-4">
            Áreas de estudio
          </p>
          <h2
            data-testid="courses-title"
            className="text-2xl md:text-3xl lg:text-4xl font-medium tracking-tight text-white mb-4"
          >
            Cursos donde te podemos ayudar
          </h2>
          <p className="text-base text-[#a1a1aa] leading-relaxed">
            Selecciona el ramo en el que necesitas apoyo y te orientamos con
            la mejor modalidad para ti.
          </p>
        </div>

        {/* Main courses grid */}
        <div className="grid sm:grid-cols-2 gap-4 lg:gap-5 mb-8">
          {mainCourses.map((course) => {
            const Icon = course.icon;
            return (
              <button
                key={course.name}
                onClick={() => onCourseSelect(course.name)}
                data-testid={`course-card-${course.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group text-left p-6 lg:p-8 rounded-2xl bg-[#242429]/60 border border-white/5 hover:border-[#9d4edd]/40 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-[#9d4edd]/10 text-[#c77dff] flex-shrink-0 group-hover:bg-[#9d4edd]/15 transition-colors">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-white mb-2 group-hover:text-[#e0aaff] transition-colors">
                      {course.name}
                    </h3>
                    <p className="text-sm text-[#a1a1aa] leading-relaxed">
                      {course.description}
                    </p>
                    <span className="inline-block mt-4 text-sm text-[#9d4edd] font-medium group-hover:text-[#c77dff] transition-colors">
                      Solicitar apoyo &rarr;
                    </span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Future courses */}
        <div className="grid sm:grid-cols-2 gap-4 lg:gap-5">
          {futureCourses.map((course) => {
            const Icon = course.icon;
            return (
              <div
                key={course.name}
                data-testid={`course-card-${course.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="p-6 lg:p-8 rounded-2xl bg-[#242429]/30 border border-white/[0.03] opacity-60"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-white/[0.03] text-[#71717a] flex-shrink-0">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-[#a1a1aa] mb-2">
                      {course.name}
                    </h3>
                    <p className="text-sm text-[#71717a] leading-relaxed">
                      {course.description}
                    </p>
                    <span className="inline-block mt-4 text-xs text-[#71717a] uppercase tracking-wider">
                      Próximamente
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
